import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { RouterProvider } from "react-router-dom";
import { Errors } from "./errors/errors.component";

import { Footer } from "./Footer";
import { Header } from "./Header";
import "./index.css";
import { AppRouter } from "./app.router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CustomerContext from "./courses/customer.context";
import { useCustomerDetails } from "./courses/useCustomerDetails";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const routesWithoutHeader = ["/deeplink"];

const queryClient = new QueryClient();

const App = () => {
  const { customerDetails } = useCustomerDetails();
  return (
    <ErrorBoundary FallbackComponent={Errors}>
      <QueryClientProvider client={queryClient}>
        <CustomerContext.Provider value={customerDetails}>
          {!routesWithoutHeader.some((x) =>
            window.location.pathname.startsWith(x),
          ) && <Header />}
          <div className="flex-grow">
            <RouterProvider router={AppRouter} fallbackElement={<Errors />} />
          </div>
        </CustomerContext.Provider>
        <Footer />
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

// eslint-disable-next-line jest/require-hook
root.render(<App />);
